import type { AnimationI } from "tweenly"
import { PayloadAction } from "@reduxjs/toolkit"
import { compareAnimations } from "../../../../helpers/animation.helpers"
import { ObjectsStateT } from "../../objects.slice"
import { animationNode } from "./animationNode"
import { UpdateOffsetAnimationT } from "./animationTypes"

export const relativeDurationAnimationBaseAction = (
    state: ObjectsStateT,
    action: PayloadAction<UpdateOffsetAnimationT>
) => {
    const { animation, offset, objectId } = action.payload
    const newDuration = +animation.duration + +offset
    if (newDuration <= 0) return

    const currentAnimations = state.value[objectId]?.animations ?? {}
    const updatedAnimations = {
        ...currentAnimations,
        [animation.id]: animationNode(currentAnimations[animation.id] ?? ({} as AnimationI), {
            property: "duration",
            value: newDuration,
        }),
    }

    const sortedAnimations = Object.values(currentAnimations).sort(compareAnimations)

    for (const anim of sortedAnimations) {
        if (
            anim &&
            anim.objectId === objectId &&
            anim.delay >= +animation.delay + +animation.duration &&
            anim.tween.name === animation.tween.name
        ) {
            const newDelay = +anim.delay + +offset
            if (newDelay >= 0) {
                updatedAnimations[anim.id] = animationNode(
                    currentAnimations[anim.id] ?? ({} as AnimationI),
                    {
                        property: "delay",
                        value: newDelay,
                    }
                )
            }
        }
    }

    state.value = {
        ...state.value,
        [objectId]: {
            ...state.value[objectId],
            animations: updatedAnimations,
        },
    }
}
